module.exports = __webpack_public_path__ + "img/IoTkyoto_logo_C1600px.694f0d61.png";